module.exports = "/assets/packs/images/e7665f7516ae72393bb94de4717521e1.png";